import { AUTH_TOKEN_KEY } from '@/lib/constants/authentication'

const getAuthToken = () => {
  const userSessionString = localStorage.getItem(AUTH_TOKEN_KEY) || null
  if (!userSessionString) {
    return null
  }

  let userSession
  try {
    userSession = JSON.parse(userSessionString)
  } catch (error) {
    userSession = null
  }

  if (!userSession || !userSession.expiredAt) {
    return null
  }

  const now = new Date()
  let expiredAtString = userSession.expiredAt + 'Z'
  const expiresAt = new Date(expiredAtString)

  if (now > expiresAt) {
    return null
  }

  return userSession.sessionToken
}

export default getAuthToken
